export * from './print.component';
export * from './print-binding.directive';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/print/print/index.ts